import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "page-footer",
  role: "contentinfo"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center flex-1 text-muted" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "hidden-md-down fw-700" }, [
    /*#__PURE__*/_createTextVNode("2023 MEDIA DEPT by "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "http://mediadept.co.jp/",
      class: "text-primary fw-500",
      title: "http://mediadept.co.jp/",
      target: "_blank"
    }, "mediadept.co.jp")
  ]),
  /*#__PURE__*/_createElementVNode("span", {
    "data-ver": "ver 20260902041752",
    class: "hidden-md-down fw-700",
    style: {"margin-left":"20px"}
  }, "v 1.0.2")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_4 = {
  key: 1,
  class: "badge badge-warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      (_ctx.isProd())
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Production"))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, "Development"))
    ])
  ]))
}